import { Country } from '@bigcommerce/checkout-sdk'
import store from '../store'
import { setGlobalIsPending } from '../store/actions'
import { createAddress, AddressInfo } from '../request/apis'
import { constants, storage } from '../utils'
// import Base64 from '../utils/base64'

export const addNewB3Address = async ({
  newAddress, // it's from the form to be the shipping address,but not a intact shipping address
  billingSameAsShipping,
  isBillingMode,
  b2bCustomFields,
  checkoutSettings,
}: {
  newAddress: any
  billingSameAsShipping?: boolean
  isBillingMode?: boolean,
  b2bCustomFields?: any,
  checkoutSettings?: any
}) => {
  const {
    company: {
      companyBasicInfo: { companyName },
      addresses,
      countries,
    },
  } = store.getState()

  const isShipping = isBillingMode ? 0 : 1
  const isBilling = checkoutSettings['shipping.singleAddress.allowAsBilling'] ?
    (isBillingMode && Number(isBillingMode)) || Number(billingSameAsShipping) : 0

  const {
    shouldSaveAddress,
    address1: addressLine1,
    address2: addressLine2,
    city,
    company,
    countryCode,
    firstName,
    lastName,
    phone: phoneNumber,
    postalCode: zipCode,
    stateOrProvinceCode: stateCode,
    stateOrProvince, // it will be none when selected a sate instead of input the state,but shipping address will fill it by the state code
  } = newAddress

  // if we have company addresses & newAddress's addressId equal undefined,it's a address selected action
  if (addresses.length && newAddress.addressId === undefined) return

  let extraFields: any = []
  if (b2bCustomFields && JSON.stringify((b2bCustomFields as any)) !== '{}') {
    extraFields = Object.keys(b2bCustomFields).map((item: any) => {
        return {
            fieldName: item,
            fieldValue: b2bCustomFields[item]
        }
    })
  }

  const currentCompanyName = storage.B3FormCompanyName.getValue() || companyName

  const label = company.includes(currentCompanyName) && company.indexOf(currentCompanyName) === 0 ? '' : company.split('/')[0]

  const selectedCountry: Country = countries.find(
    (country: { code: any }) => country.code === countryCode
  )
  const countryName = selectedCountry?.name ?? '' // country name is none,but shipping address's country will be filled by the country code
  const stateName = stateCode
    ? selectedCountry?.subdivisions.find(state => state.code === stateCode)
      ?.name
    : stateOrProvince //same as country name

  const B3RoleId = storage.B3RoleId.getValue()

  const { ADMIN, SENIOR } = constants.B3Role
  
  if (shouldSaveAddress && ([ADMIN, SENIOR].includes(B3RoleId))) {
    store.dispatch(setGlobalIsPending(true))

    try {
      await createAddress(storage.B3CompanyId.getValue(), {
        addressLine1,
        addressLine2,
        city,
        label,
        country: {
          countryName,
          countryCode,
        },
        firstName,
        lastName,
        phoneNumber,
        state: {
          stateName,
          stateCode,
        },
        zipCode,
        isShipping,
        isBilling,
        extraFields,
        isCheckout: true,
      } as AddressInfo)

    } finally {
      store.dispatch(setGlobalIsPending(false))
    }
  }

  storage.B3FormCompanyName.removeValue()
}
